export default __webpack_public_path__ + "static/media/slider-animation.5cf18cdf.gif";